import api from './client';

export const getAdminStats    = ()            => api.get('/admin/stats');
export const getAdminUsers    = (params)      => api.get('/admin/users', { params });
export const getAdminUser     = (id)          => api.get(`/admin/users/${id}`);
export const updateAdminUser  = (id, data)    => api.patch(`/admin/users/${id}`, data);
export const deleteAdminUser  = (id)          => api.delete(`/admin/users/${id}`);
export const getAdminPlans    = ()            => api.get('/admin/plans');
export const updateAdminPlan  = (id, data)    => api.patch(`/admin/plans/${id}`, data);
export const getAdminSettings    = ()            => api.get('/admin/settings');
export const updateAdminSettings = (data)        => api.patch('/admin/settings', data);
export const createAdminUser     = (data)        => api.post('/admin/users', data);
export const resetAdminPassword  = (id, data)    => api.post(`/admin/users/${id}/reset-password`, data);
